import React, { Component } from 'react';
import { ScrollCustomStyles } from 'components';
import AntTransfer, { TransferProps as AntTransferProps } from 'antd/lib/transfer';

import styles from './Transfer.module.scss';

interface TransferProps extends AntTransferProps {}

class Transfer extends Component<TransferProps> {
	render() {
		return (
			<ScrollCustomStyles>
				<AntTransfer {...this.props} className={styles.transfer} />
			</ScrollCustomStyles>
		);
	}
}

export default Transfer;
